import PropTypes from "prop-types";

const formatMessageDate = (dateVal) => {
  try {
    const date = new Date(dateVal);
    if (isNaN(date.getTime())) return "";

    const now = new Date();
    const isToday = date.toDateString() === now.toDateString();

    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const timeStr = `${hours}:${minutes}`;

    if (isToday) {
      return timeStr;
    } else {
      return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()} ${timeStr}`;
    }
  } catch (err) {
    return "";
  }
};

export const Message = ({ userName = "", message = "", date = new Date(), isOwnMessage = false }) => {
  const formattedDate = formatMessageDate(date);

  return (
    <div className={`flex w-full mb-3.5 ${isOwnMessage ? "justify-end" : "justify-start"}`}>
      <div
        className={`max-w-[70%] rounded-2xl p-4 shadow-sm border ${
          isOwnMessage
            ? "bg-[#2563EB] border-[#1D4ED8] text-white rounded-tr-none"
            : "bg-slate-100 border-slate-200 text-slate-800 rounded-tl-none"
        }`}
      >
        {!isOwnMessage && (
          <div className="text-xs font-semibold text-blue-600 mb-1.5">
            {userName}
          </div>
        )}
        <p className="text-sm whitespace-pre-wrap leading-relaxed font-normal">{message}</p>
        <div
          className={`text-[10px] mt-1.5 text-right font-medium block ${
            isOwnMessage ? "text-blue-200" : "text-slate-400"
          }`}
        >
          {formattedDate}
        </div>
      </div>
    </div>
  );
};

Message.propTypes = {
  userName: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  date: PropTypes.any.isRequired,
  isOwnMessage: PropTypes.bool,
};
